import React from 'react';
import { SocialNetwork } from '@actus/types';
import { SquareSvgProps } from '@icons/icon.types';
import { useTranslation } from '@locales/useTranslation.hook';

function FacebookLogoIcon({ title, fillColor = '#2D3049', size = 24, ...props }: SquareSvgProps) {
  const { t } = useTranslation(['common']);
  return (
    <svg height={size} viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>{title || t('common.share', { socialNetworkName: SocialNetwork.Facebook })}</title>
      <path
        d="M12.417 19.5v-6.667H10.75v-2.5h1.667c0-4.296.183-4.583 5.416-4.583v2.5c-2.758 0-2.5.154-2.5 2.083h2.5v2.5h-2.5V19.5h-2.916zM2 20.333C2 21.254 2.746 22 3.667 22h16.666c.921 0 1.667-.746 1.667-1.667V3.667C22 2.746 21.254 2 20.333 2H3.667C2.746 2 2 2.746 2 3.667v16.666z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { FacebookLogoIcon };
